import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DoCheck,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './new-hampshire-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { RequestService } from '../../../_services/request/request.service';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-new-hampshire',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './new-hampshire.component.html',
  styleUrl: './new-hampshire.component.scss',
  host: {
    class: 'state-wrapper',
  },
})
export class NewHampshireComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('new-hampshire', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('new-hampshire', null);
    }
  }

  constructor(private requestService: RequestService) {
    super();
  }
  override calculatePremium(c: Control) {
      return {
        id: 1,
        name: this.requestService
          .getLiabilityLimitForState('new-hampshire')
          .split('.')[0],
      };
  }
}
